// src/utils/deliveryHelper.js
import { buildGoodDeliveryQuery } from './goodDeliveryConfig'; // Adjust path
/**
 * Standardizes how we get an ID from an order object
 */
export const getOrderUniqueId = (order) => {
  return String(order?.OrderID ?? order?.idsOrder ?? '');
};
/**
 * Resolves product names and quantities for delivery formatting
 */
export const buildProductNames = (order, t) => {
  const names = order.order_items?.map((item) => {
    // This assumes you also move resolveProductName to a shared utility
    // If not, you can pass it as a callback or define a basic version here
    const name = item.product?.Name || item.product?.name || t('Produit');
    return name;
  }) || [];
  return names.filter(Boolean).join(', ');
};

export const buildTotalQuantity = (order) => {
  return (order.order_items || []).reduce((acc, item) => acc + Number(item.Quantity ?? 0), 0);
};

/**
 * Main Delivery Export Logic
 */
export const sendToGoodDelivery = async (order, t, setLoader) => {
  if (!order) return;

  const customer = order.customer_info || {};
  const fullname = (customer.Name || '').trim();
  const phone = (customer.Phone || '').trim();
  const city = (customer.City || customer.city || '').trim();
  const address = (customer.Address || '').trim();
  const note = (order.notes || '').trim();
  const priceValue = Number(order.payment?.Amount ?? 0);
  const price = Number.isFinite(priceValue) ? priceValue.toFixed(2) : '0';
  
  const productsTitle = buildProductNames(order, t) || 'Commande WMG';
  const totalQuantity = buildTotalQuantity(order) || 1;

  if (!fullname || !phone || !city || !address) {
    alert('Informations client incomplètes pour l\'export vers GoodDelivery.');
    return;
  }

  const query = buildGoodDeliveryQuery({
    fullname,
    phone,
    city,
    address,
    price,
    product: productsTitle,
    qty: String(totalQuantity),
    note,
    change: '0',
    openpackage: '1',
  });

  const url = `https://gooddelivery.ma/addcolis.php?${query}`;

  try {
    if (setLoader) setLoader(true);
    
    // Attempt the fetch
    const response = await fetch(url, {
      method: 'GET',
      mode: 'no-cors',
    });

    if (!response || response.type === 'opaque') {
      alert('Commande envoyée à GoodDelivery.');
    } else if (response.ok) {
      alert('Commande envoyée à GoodDelivery.');
    } else {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error("Delivery Error:", error);
    // Fallback to popup if CORS fails
    const popup = window.open(url, '_blank', 'noopener,noreferrer');
    if (popup) {
      popup.focus();
      alert("La requête a été ouverte dans un nouvel onglet.");
    } else {
      alert("Échec de l'export.");
    }
  } finally {
    if (setLoader) setLoader(false);
  }
};